module.exports = __webpack_public_path__ + "img/37.excellent.0630bb46.svg";